/**
 * Joins an array strings separated by a space.
 */
export const join = (...classNames) => classNames.join(' ');
